import { createSelector } from 'reselect';
// import { plpOnLandingProducts } from '../types/plpOnLanding';
import { getProductProps } from '../utils/productUtils';

const getPlpOnLanding = (
  state: import('../types/rootState').RootState
): import('../types/plpOnLanding').plpOnLandingProducts => state.plpOnLanding;

const getPlpOnLandingProducts = createSelector(getPlpOnLanding, plpOnLanding => {
  return getProductProps(plpOnLanding?.products);
});

const getPlpOnLandingData = createSelector(getPlpOnLanding, plpOnLanding => {
  return plpOnLanding || {};
});

const getPlpOnLandingSource = createSelector(getPlpOnLanding, plpOnLanding => {
  return plpOnLanding?.plpOnlandingSource;
});

const getPlpOnLandingHeading = createSelector(getPlpOnLanding, plpOnLanding => {
  return plpOnLanding?.heading;
});

export {
  getPlpOnLandingProducts,
  getPlpOnLandingSource,
  getPlpOnLandingData,
  getPlpOnLandingHeading
};
